require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./reducing-fear-of-crime.json") })
        }
      }, "path---reducing-fear-of-crime");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---reducing-fear-of-crime!./.cache/json/reducing-fear-of-crime.json
// module id = 970
// module chunks = 231608221292675